import Bowser from 'bowser';

const FACEBOOK_IN_APP_BROWSER_MARKERS = ['FBAN', 'FBAV', 'FBIOS', 'FB_IAB', 'FB4A', 'FBSS', 'FBID'];

const getNavigator = () => (typeof navigator !== 'undefined' ? navigator : undefined);
const getWindow = () => (typeof window !== 'undefined' ? window : undefined);

export const getUserAgent = () => {
  const currentNavigator = getNavigator();
  const currentWindow = getWindow();

  return currentNavigator?.userAgent || currentNavigator?.vendor || currentWindow?.opera || '';
};

export const getBrowserParser = (userAgent = getUserAgent()) => {
  if (!userAgent) {
    return null;
  }

  return Bowser.getParser(userAgent);
};

export const isFacebookInAppBrowser = (userAgent = getUserAgent()) => {
  if (!userAgent) {
    return false;
  }

  return FACEBOOK_IN_APP_BROWSER_MARKERS.some((marker) =>
    new RegExp(`\\b${marker}\\b`, 'i').test(userAgent)
  );
};

export const isAppleDevice = (userAgent = getUserAgent()) => {
  const parser = getBrowserParser(userAgent);
  const currentNavigator = getNavigator();
  const platform = currentNavigator?.platform || '';
  const maxTouchPoints = currentNavigator?.maxTouchPoints || 0;
  const osName = parser?.getOSName(true) || '';

  if (['ios', 'macos'].includes(osName)) {
    return true;
  }

  if (/iPhone|iPad|iPod|Mac/i.test(platform)) {
    return true;
  }

  return platform === 'MacIntel' && maxTouchPoints > 1;
};

export const shouldShowGoogleSso = (userAgent = getUserAgent()) =>
  !isFacebookInAppBrowser(userAgent);

export const shouldShowAppleSso = (userAgent = getUserAgent()) => isAppleDevice(userAgent);

export const getSsoBrowserEnvironment = () => ({
  isFacebookInAppBrowser: isFacebookInAppBrowser(),
  isAppleDevice: isAppleDevice(),
  shouldShowGoogleSso: shouldShowGoogleSso(),
  shouldShowAppleSso: shouldShowAppleSso()
});
